<template>
  <div class="container">
    <h1>Editace materiálů</h1>
  </div>
</template>

<script>
export default {
  name: "AdminMaterialsView"
}
</script>

<style scoped>
</style>